/**
 * Neon top progress — shown while CMS app-data is fetching.
 * Matches the dark + lime IG visual language without blocking paint.
 */
export default function LoadingBar({ active }) {
  return (
    <div
      className={`fixed top-0 inset-x-0 z-[100] pointer-events-none transition-opacity duration-500 ${
        active ? 'opacity-100' : 'opacity-0'
      }`}
      role="progressbar"
      aria-hidden={!active}
      aria-valuetext={active ? 'Loading' : undefined}
    >
      <div className="h-[2px] w-full bg-primary/10 overflow-hidden">
        <div
          className={`h-full bg-primary shadow-glow-sm ${
            active ? 'roi-loading-bar' : 'w-0'
          }`}
        />
      </div>
    </div>
  );
}
